import store from '../../stores'

import * as fromExport from '../../stores/ducks/export'

export default function handleExport (msg) {
  if (msg) {
    store.dispatch(fromExport.receiveUpdate(msg.doc))
  }
}
